import { FC } from 'react';

import Select from 'components/Select';

import { optionsConfig } from 'components/OrderStatus';
import { OrderStatus } from '__generated__/OrderStatus_order.graphql';

const keys: OrderStatus[] = [
  'abandoned',
  'pending',
  'advance',
  'paid',
  'canceled',
  'trash',
];

const OrderStatusSelect: FC = () => (
  <Select
    name="status"
    keys={keys}
    optionsConfig={optionsConfig}
    label="Užsakymo statusas"
  />
);

export default OrderStatusSelect;
